export const API_URL = "https://tslibrary-api.trustedsource.eu";
export default API_URL;
